import { CustomsDeclarationPayload } from '~/types/CustomsDeclaration';
import { CustomsItemPayload } from '~/types/CustomsItem';
import { OrderSelection } from '~/types/Order';
import { ActionKeys } from './constants';
import { TrackingAppLocation } from '~/utils/TrackingHelper/types';

export function createCustomsItem(
  orderSelection: OrderSelection,
  customsItemPayload: CustomsItemPayload,
) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_CREATE,
    payload: {
      customsItemPayload,
      orderSelection,
    },
  };
}

export function createCustomsItemSuccess() {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_CREATE_SUCCESS,
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createCustomsItemError(err: any) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_CREATE_ERROR,
    payload: {
      err,
    },
  };
}

export function editCustomsItem(
  appLocation: TrackingAppLocation,
  orderSelection: OrderSelection,
  customsItemPayload: CustomsItemPayload,
  initialValues: CustomsItemPayload,
  trackingData?: {
    transactionId?: string;
    location?: string;
    senderCountry?: string;
    recipientCountry?: string;
  },
) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_UPDATE,
    payload: {
      appLocation,
      customsItemPayload,
      orderSelection,
      initialValues,
      trackingData,
    },
  };
}

export function deleteCustomsItem(
  orderSelection: OrderSelection,
  initialValues: CustomsItemPayload[],
) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_DELETE,
    payload: {
      orderSelection,
      initialValues,
    },
  };
}

export function deleteCustomsItemSuccess() {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_DELETE_SUCCESS,
  };
}

export function deleteCustomsItemError(error: string) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_DELETE_ERROR,
    payload: {
      error,
    },
  };
}

export function editCustomsItemSuccess() {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_UPDATE_SUCCESS,
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function editCustomsItemError(err: any) {
  return <const>{
    type: ActionKeys.CUSTOMS_ITEM_UPDATE_ERROR,
    payload: {
      err,
    },
  };
}

export function editCustomsDeclaration(
  appLocation: TrackingAppLocation,
  orderSelection: OrderSelection,
  customsDeclarationPayload: CustomsDeclarationPayload,
  initialValues: CustomsDeclarationPayload,
  trackingData?: {
    transactionId?: string;
    location?: string;
    senderCountry?: string;
    recipientCountry?: string;
    eori_display?: boolean;
    eelpfc_display?: boolean;
    b13a_display?: boolean;
  },
) {
  return <const>{
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE,
    payload: {
      appLocation,
      orderSelection,
      customsDeclarationPayload,
      initialValues,
      trackingData,
    },
  };
}

export function editCustomsDeclarationSuccess() {
  return <const>{
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE_SUCCESS,
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function editCustomsDeclarationError(err: any) {
  return <const>{
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE_ERROR,
    payload: {
      err,
    },
  };
}

export type CustomsActions =
  | ReturnType<typeof createCustomsItem>
  | ReturnType<typeof createCustomsItemSuccess>
  | ReturnType<typeof createCustomsItemError>
  | ReturnType<typeof editCustomsItem>
  | ReturnType<typeof editCustomsItemSuccess>
  | ReturnType<typeof editCustomsItemError>
  | ReturnType<typeof deleteCustomsItem>
  | ReturnType<typeof deleteCustomsItemSuccess>
  | ReturnType<typeof deleteCustomsItemError>
  | ReturnType<typeof editCustomsDeclaration>
  | ReturnType<typeof editCustomsDeclarationSuccess>
  | ReturnType<typeof editCustomsDeclarationError>;
